import { Component, HostBinding, HostListener, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lm-drawer-side',
  template: '<ng-content></ng-content>',
  animations: [
    trigger('toggleSide', [
      state('collapsed', style({ width: '0' })),
      state('expanded', style({ width: '*' })),
      transition('collapsed <=> expanded', animate('400ms cubic-bezier(0.17, 0.04, 0.03, 0.94)'))
    ])
  ]
})
export class LMDrawerSideComponent {
  @Input() collapsed = false;

  @HostBinding('@toggleSide') get sideState(): 'collapsed' | 'expanded' {
    return this.collapsed ? 'collapsed' : 'expanded';
  }

  @HostListener('@toggleSide.start') toggleSideStart() {
    if (!this.collapsed) {
      this.collapsedDone = false;
    }
  }

  @HostListener('@toggleSide.done') toggleSideDone() {
    if (this.collapsed) {
      this.collapsedDone = true;
    }
  }

  @HostBinding('class.hidden') collapsedDone = false;
}
